import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import * as styles from "./style.css";
import { createClassNames } from "../../../../infrastructure/helpers";

export default class UQFormErrors extends PureComponent {

  static propTypes = {
    errors: PropTypes.string,
    textClass: PropTypes.string
  };

  render() {
    const classNames = createClassNames([styles.errorText, this.props.textClass]);

    return (
      <div className={classNames}>
        {this.props.error}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/uq-forms/components/form-errors/index.jsx